import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IFormCheckbox } from '../../_shared/models/form/form-checkbox.model';
import { FormElementBase } from '../_directives/form-element-base.directive';
import { CheckboxComponent } from '../../checkbox/checkbox.component';
import { ReactiveFormsModule } from '@angular/forms';


@Component({
    selector: 'sirius-form-checkbox',
    templateUrl: './form-checkbox.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CheckboxComponent, ReactiveFormsModule]
})
export class FormCheckboxComponent extends FormElementBase implements OnInit {
    config?: IFormCheckbox;

    @Input() checked = false;
    @Input() showTip = true;

    ngOnInit(): void {
        if (this.config) {
            this.name = this.config.name;
            this.label = this.config.label;
            this.formFieldDependencies = this.config.dependentFormFieldComponents;
            this.validation = this.config.validation;
            this.form = this.config.form;
            this.identifier = this.config.identifier ?? '';
            this.checked = this.config.checked;
            this.showTip = this.config.showTip ?? true;
        }
    }
}
